export default "__VITE_ASSET__B5WB8J5H__"